/**
 * @enum FONT_FAMILY
 * @type {{ARIAL_BLACK: string, CURSIVE: string, IMPACT: string, GEORGIA: string, ARIAL: string, MONOSPACE: string, LUCIDA_GRANDE: string, HELVETICA: string}}
 */
export const FONT_FAMILY = {
  ARIAL: 'ARIAL',
  ARIAL_BLACK: 'ARIAL_BLACK',
  CURSIVE: 'CURSIVE',
  GEORGIA: 'GEORGIA',
  HELVETICA: 'HELVETICA',
  IMPACT: 'IMPACT',
  LUCIDA_GRANDE: 'LUCIDA_GRANDE',
  MONOSPACE: 'MONOSPACE',
  GOOGLE_ANTON: 'GOOGLE_ANTON',
  GOOGLE_BEBAS_NEUE: 'GOOGLE_BEBAS_NEUE',
  GOOGLE_FREDOKA_ONE: 'GOOGLE_FREDOKA_ONE',
  GOOGLE_INCONSOLATA: 'GOOGLE_INCONSOLATA',
  GOOGLE_KALAM: 'GOOGLE_KALAM',
  GOOGLE_MULISH: 'GOOGLE_MULISH',
  GOOGLE_NEUCHA: 'GOOGLE_NEUCHA',
  GOOGLE_OPEN_SANS: 'GOOGLE_OPEN_SANS',
  GOOGLE_OSWALD: 'GOOGLE_OSWALD',
  GOOGLE_PERMANENT_MARKER: 'GOOGLE_PERMANENT_MARKER',
  GOOGLE_ROBOTO: 'GOOGLE_ROBOTO',
  GOOGLE_RUSSO_ONE: 'GOOGLE_RUSSO_ONE',
};

export const googleFontInfo = [
  {
    font: FONT_FAMILY.GOOGLE_ANTON,
    fontFamily: 'Anton, sans-serif',
    stylesheet: 'https://fonts.googleapis.com/css2?family=Anton&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BEBAS_NEUE,
    fontFamily: `'Bebas Neue', sans-serif`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_FREDOKA_ONE,
    fontFamily: `Fredoka One', cursive`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_INCONSOLATA,
    fontFamily: 'Inconsolata, cursive',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Inconsolata:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_KALAM,
    fontFamily: 'Kalam, cursive',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Kalam:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_MULISH,
    fontFamily: 'Mulish, sans-serif',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,400;0,700;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_NEUCHA,
    fontFamily: 'Neucha, cursive',
    stylesheet: 'https://fonts.googleapis.com/css2?family=Neucha&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_OPEN_SANS,
    fontFamily: `'Open Sans', sans-serif`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_OSWALD,
    fontFamily: 'Oswald, sans-serif',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PERMANENT_MARKER,
    fontFamily: `'Permanent Marker', cursive`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ROBOTO,
    fontFamily: 'Roboto, sans-serif',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_RUSSO_ONE,
    fontFamily: `'Russo One', sans-serif`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Russo+One&display=swap',
  },
];

/**
 * Gets the font-family property for a CardElementText based on its CardElementConfiguration.
 *
 * @param {Object} cardElementConfiguration The CardElementConfiguration.
 * @returns {*|undefined}
 */
export const getCardElementTextFontFamily = cardElementConfiguration => {
  const { font_family: fontFamily } = cardElementConfiguration ?? {};
  const googleFontDetails = googleFontInfo.find(x => x.font === fontFamily);

  return googleFontDetails?.fontFamily ?? fontFamily ?? undefined;
};

/**
 * Determines whether a FONT_FAMILY is Google Fonts.
 *
 * @param {FONT_FAMILY} fontFamily The FONT_FAMILY.
 * @returns {boolean}
 */
export const isGoogleFontFamily = fontFamily => {
  return !!fontFamily?.contains('GOOGLE_');
};

/**
 * @enum FONT_STYLE
 * @type {{ITALIC: string, NORMAL: string}}
 */
export const FONT_STYLE = {
  NORMAL: 'NORMAL',
  ITALIC: 'ITALIC',
};

/**
 * @enum TEXT_ALIGN
 * @type {{CENTER: string, LEFT: string, RIGHT: string}}
 */
export const TEXT_ALIGN = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT',
};

/**
 * @enum TEXT_TRANSFORM
 * @type {{CAPITALIZE: string, UPPERCASE: string, LOWERCASE: string, NONE: string}}
 */
export const TEXT_TRANSFORM = {
  CAPITALIZE: 'CAPITALIZE',
  UPPERCASE: 'UPPERCASE',
  LOWERCASE: 'LOWERCASE',
  NONE: 'NONE',
};
